// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__FkKZN","content":"style_content__RVEFt","title":"style_title__dH-ke","form":"style_form__F+6z2","actions":"style_actions__QXuPH"};